export enum EDocumentIdentite {
    carteidentite = "Carte d'identité",
	passeport = "Passeport",
    titresejour = "Titre de séjour"
}